var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	26137: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [0,14], () => (__webpack_require__.e("node_modules_angular_core_fesm2020_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 22560))))))),
	98462: () => (loadSingletonVersionCheckFallback("default", "@ecovium/common", [0,14], () => (__webpack_require__.e("node_modules_ecovium_common_src_index_js-_68f91").then(() => (() => (__webpack_require__(/*! @ecovium/common */ 94385))))))),
	31764: () => (loadSingletonVersionCheckFallback("default", "@angular/common/http", [0,14], () => (__webpack_require__.e("node_modules_angular_common_fesm2020_http_mjs-_68761").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 58987))))))),
	20954: () => (loadSingletonVersionCheckFallback("default", "@angular/forms", [0,14], () => (__webpack_require__.e("node_modules_angular_forms_fesm2020_forms_mjs-_2e341").then(() => (() => (__webpack_require__(/*! @angular/forms */ 2508))))))),
	9123: () => (loadSingletonVersionCheckFallback("default", "@ngrx/effects", [0,14], () => (__webpack_require__.e("node_modules_ngrx_effects_fesm2020_ngrx-effects_mjs-_a49a1").then(() => (() => (__webpack_require__(/*! @ngrx/effects */ 5405))))))),
	11399: () => (loadSingletonVersionCheckFallback("default", "@ngrx/store", [0,14], () => (__webpack_require__.e("node_modules_ngrx_store_fesm2020_ngrx-store_mjs-_62231").then(() => (() => (__webpack_require__(/*! @ngrx/store */ 23488))))))),
	87411: () => (loadSingletonVersionCheckFallback("default", "@ngrx/store-devtools", [0,14], () => (__webpack_require__.e("node_modules_ngrx_store-devtools_fesm2020_ngrx-store-devtools_mjs-_556c1").then(() => (() => (__webpack_require__(/*! @ngrx/store-devtools */ 55242))))))),
	86104: () => (loadSingletonVersionCheckFallback("default", "@angular/router", [0,14], () => (__webpack_require__.e("node_modules_angular_router_fesm2020_router_mjs-_6f000").then(() => (() => (__webpack_require__(/*! @angular/router */ 60124))))))),
	4087: () => (loadSingletonVersionCheckFallback("default", "@angular/common", [0,14], () => (__webpack_require__.e("node_modules_angular_common_fesm2020_common_mjs-_ec491").then(() => (() => (__webpack_require__(/*! @angular/common */ 94666))))))),
	86357: () => (loadSingletonVersionCheckFallback("default", "@ecovium/ng-common", [0,14], () => (__webpack_require__.e("node_modules_ecovium_ng-common_fesm2020_ecovium-ng-common_mjs-_82191").then(() => (() => (__webpack_require__(/*! @ecovium/ng-common */ 52626))))))),
	83318: () => (loadSingletonVersionCheckFallback("default", "@ecovium/ng-localization", [0,14], () => (__webpack_require__.e("node_modules_ecovium_ng-localization_fesm2020_ecovium-ng-localization_mjs-_58b90").then(() => (() => (__webpack_require__(/*! @ecovium/ng-localization */ 31766))))))),
	15260: () => (loadSingletonVersionCheckFallback("default", "lodash", [0,4], () => (__webpack_require__.e("node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(/*! lodash */ 92938))))))),
	24936: () => (loadSingletonVersionCheckFallback("default", "@angular/animations", [0,14], () => (__webpack_require__.e("node_modules_angular_animations_fesm2020_animations_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations */ 24851))))))),
	49117: () => (loadSingletonVersionCheckFallback("default", "@ecovium/events", [0,14], () => (__webpack_require__.e("node_modules_ecovium_events_src_index_js-_6e6c0").then(() => (() => (__webpack_require__(/*! @ecovium/events */ 56957))))))),
	44639: () => (loadSingletonVersionCheckFallback("default", "@ecovium/localization", [0,14], () => (__webpack_require__.e("node_modules_ecovium_localization_src_index_js-_a85a1").then(() => (() => (__webpack_require__(/*! @ecovium/localization */ 46744))))))),
	35379: () => (loadSingletonVersionCheckFallback("default", "@angular/animations/browser", [0,14], () => (__webpack_require__.e("node_modules_angular_animations_fesm2020_browser_mjs-_54671").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 5787)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"src_bootstrap_ts": [
		26137,
		98462,
		31764,
		20954,
		9123,
		11399,
		87411,
		86104,
		4087,
		86357,
		83318,
		15260,
		24936,
		49117,
		44639,
		35379
	],
	"node_modules_angular_animations_fesm2020_browser_mjs-_54670": [
		24936,
		26137
	],
	"node_modules_angular_common_fesm2020_http_mjs-_68760": [
		4087,
		26137
	],
	"node_modules_angular_common_fesm2020_common_mjs-_ec490": [
		26137
	],
	"node_modules_angular_forms_fesm2020_forms_mjs-_2e340": [
		4087,
		26137
	],
	"node_modules_angular_router_fesm2020_router_mjs-_6f001": [
		26137,
		4087
	],
	"node_modules_ecovium_common_src_index_js-_68f90": [
		15260
	],
	"node_modules_ecovium_events_src_index_js-_6e6c1": [
		15260
	],
	"node_modules_ecovium_localization_src_index_js-_a85a0": [
		15260
	],
	"node_modules_ecovium_ng-common_fesm2020_ecovium-ng-common_mjs-_82190": [
		11399,
		15260,
		26137,
		31764,
		98462
	],
	"node_modules_ecovium_ng-localization_fesm2020_ecovium-ng-localization_mjs-_58b91": [
		26137,
		4087,
		11399,
		98462,
		15260,
		9123,
		44639,
		31764,
		86357,
		20954,
		24936
	],
	"node_modules_ngrx_effects_fesm2020_ngrx-effects_mjs-_a49a0": [
		11399,
		26137
	],
	"node_modules_ngrx_store-devtools_fesm2020_ngrx-store-devtools_mjs-_556c0": [
		26137,
		11399
	],
	"node_modules_ngrx_store_fesm2020_ngrx-store_mjs-_62230": [
		26137
	],
	"node_modules_angular_common_fesm2020_http_mjs-_68761": [
		4087
	],
	"node_modules_ecovium_ng-localization_fesm2020_ecovium-ng-localization_mjs-_58b90": [
		44639
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}